/**************************************************
 * Nombre:       Formulario_Tres
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {AccountCircleOutlined, BadgeOutlined, Mail, WhatsApp} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {PAISESINDICATIVO} from "../../Modulo_formularios/Recursos/indicativos";

const Formulario_Tres = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre'} dato={'nombre'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <IngresoSelect Icono={BadgeOutlined} nombre={'Pais'} dato={'pais'} {...props}
                                   opciones={PAISESINDICATIVO.map((it) => it.nameES)}
                                   requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <IngresoTexto Icono={WhatsApp} nombre={'Numero Celular'} dato={'celular'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <IngresoTexto Icono={Mail} nombre={'Correo'} dato={'correo'} {...props}
                                  requerido={'Campo requerido'}/>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Tres